import React from 'react';
import '../../App.css';
import Card from '../Card';

function Projects() {
    return (
    <>
    <Card/>
    </>
    )
}
export default Projects;